import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import ContactHero from './components/ContactHero';
import ContactMethods from './components/ContactMethods';
import PricingTransparency from './components/PricingTransparency';
import ContactForm from './components/ContactForm';
import ConsultationPrep from './components/ConsultationPrep';
import OfficeLocation from './components/OfficeLocation';

const ContactPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>Kontakt - AdvoCall Professional | Sofortige Rechtsberatung</title>
        <meta 
          name="description" 
          content="Kontaktieren Sie AdvoCall Professional für sofortige Rechtsberatung. Transparente Preise, 24/7 Verfügbarkeit, professionelle Anwälte. Jetzt anrufen oder Termin vereinbaren." 
        />
        <meta name="keywords" content="Rechtsberatung Kontakt, Anwalt anrufen, Rechtshilfe Frankfurt, Telefonberatung Recht, Anwalt Termin" />
        <meta property="og:title" content="Kontakt - AdvoCall Professional | Sofortige Rechtsberatung" />
        <meta property="og:description" content="Professionelle Rechtsberatung per Telefon - transparent, zugänglich und sofort verfügbar. Keine Wartezeiten, keine versteckten Kosten." />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://advocall.de/contact" />
      </Helmet>

      <Header />

      <main className="pt-0">
        {/* Hero Section */}
        <ContactHero />

        {/* Contact Methods */}
        <ContactMethods />

        {/* Pricing Transparency */}
        <PricingTransparency />

        {/* Contact Form */}
        <ContactForm />

        {/* Consultation Preparation */}
        <ConsultationPrep />

        {/* Office Location */}
        <OfficeLocation />

        {/* Emergency Contact Banner */}
        <section className="bg-gradient-to-r from-conversion-accent to-cta text-white py-8">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center">
              <h2 className="text-2xl font-bold mb-2">
                Dringender Rechtsbeistand benötigt?
              </h2>
              <p className="text-white/90 mb-4">
                Unsere Notfall-Hotline ist 24/7 für Sie erreichbar
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
                <div className="flex items-center space-x-2">
                  <div className="w-3 h-3 bg-white rounded-full animate-pulse"></div>
                  <a 
                    href="tel:09001000312"
                    className="font-mono text-xl font-bold hover:text-white/80 transition-colors"
                  >
                    0900 1000 312
                  </a>
                </div>
                <span className="text-white/80">•</span>
                <span className="text-white/90">Durchschnittlich 2 Min Wartezeit</span>
              </div>
            </div>
          </div>
        </section>
      </main>

      {/* Footer Spacer */}
      <div className="h-16"></div>
    </div>
  );
};

export default ContactPage;